var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"text-subtitle-1 font-weight-bold bg-transparent mx-2 mt-1 mb-n8",attrs:{"items":_vm.layersSelectOptions,"dense":"","flat":"","solo":"","attach":""},on:{"change":_vm.layerSelectChange},model:{value:(_vm.selectedLayerValue),callback:function ($$v) {_vm.selectedLayerValue=$$v},expression:"selectedLayerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }